import React from "react";

import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";


const OpenOrders = () => {
  const columns = [
    {
      header: "SKU",
      accessor: "sku",
      width: 12,
    },
    {
      header: "Pattern",
      accessor: "pattern",
      width: 12,
    },
    {
      header: "Reference SO",
      accessor: "reference_so",
      width: 12,
    },
    {
      header: "Reference PO",
      accessor: "reference_po",
      width: 12,
    },
    {
      header: "Brand",
      accessor: "brand",
      width: 10,
    },
    {
      header: "Rim",
      accessor: "rim",
      width: 8,
    },

    {
      header: "Size",
      accessor: "size",
      width: 10,
    },

    {
      header: "L.I./S.R.",
      accessor: "lisr",
      width: 10,
    },
    {
      header: "Pending Quantity",
      accessor: "pending_quantity",
      width: 10,
    },
  ];
     const data = [];//this data is static as of now
  // const data = [
  //   {
  //     sku: "TYR00123",
  //     pattern: "PATRIOT® R/T",
  //     brand: "PATRIOT",
  //     rim: "20",
  //     reference_so: "9932233",
  //     reference_po: "V322422",
  //     pending_quantity: "10291",
  //     size: "275/60R20",
  //     lisr: "121/118S",
  //     unitPrice: "$XYZ",
  //   },
  //   {
  //     sku: "TYR00123",
  //     pattern: "PATRIOT® R/T",
  //     brand: "PATRIOT",
  //     rim: "20",
  //     reference_so: "9932233",
  //     reference_po: "V322422",
  //     pending_quantity: "10291",
  //     size: "275/60R20",
  //     lisr: "121/118S",
  //     unitPrice: "$XYZ",
  //   },
  //   {
  //     sku: "TYR00123",
  //     pattern: "PATRIOT® R/T",
  //     brand: "PATRIOT",
  //     rim: "20",
  //     reference_so: "9932233",
  //     reference_po: "V322422",
  //     pending_quantity: "10291",
  //     size: "275/60R20",
  //     lisr: "121/118S",
  //     unitPrice: "$XYZ",
  //   },
  //   {
  //     sku: "TYR00123",
  //     pattern: "PATRIOT® R/T",
  //     brand: "PATRIOT",
  //     rim: "20",
  //     reference_so: "9932233",
  //     reference_po: "V322422",
  //     pending_quantity: "10291",
  //     size: "275/60R20",
  //     lisr: "121/118S",
  //     unitPrice: "$XYZ",
  //   },
  // ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Open Orders"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
        >
          <Table columns={columns} data={data} action={false} actionWidth={8} />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default OpenOrders;
